import { useMutation, useQueryClient } from '@tanstack/react-query';
import { riskCalculationApi } from '@/services/riskCalculationApi';
import { BaseRiskCalculation } from '@/dtos/RiskCalculations/index';
import { toast } from 'sonner';

export function useUndoReview() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => riskCalculationApi.undoReview(id),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Aprobarea a fost anulată cu succes');
        // Invalidate relevant queries to refetch data
        queryClient.invalidateQueries({ queryKey: ['risk-calculations'] });
        queryClient.invalidateQueries({ queryKey: ['flow-clinical-sessions'] });
      } else {
        toast.error(response.errorMessage || 'Eroare la anularea aprobării');
      }
    },
    onError: (error) => {
      toast.error('Eroare la anularea aprobării');
      console.error('Failed to undo review:', error);
    },
  });
}
